(()=>{'use strict';
const hosts=new Set(['vv247recovery.co.uk','www.vv247recovery.co.uk','h74xmh-b9.myshopify.com']);
function trusted(value){
 if(typeof value!=='string'||value!==value.trim()||!/^https:\/\//i.test(value))return null;
 try{const u=new URL(value);return u.protocol==='https:'&&!u.username&&!u.password&&!u.port&&hosts.has(u.hostname)?u:null;}catch{return null;}
}
function payment(value){
 const u=trusted(value);if(!u)return null;
 const invoice=/^\/99167174984\/invoices\/[a-f0-9]{32}\/?$/i.test(u.pathname);
 const checkout=/^\/checkouts\/[a-z0-9_-]+(?:\/[a-z0-9_-]+)*\/?$/i.test(u.pathname);
 return invoice||checkout?u:null;
}
function portal(value){
 const u=trusted(value);if(!u)return null;
 const params=new URLSearchParams(u.hash.slice(1)),tokens=params.getAll('vv247');
 return tokens.length===1&&/^[A-Za-z0-9._~-]{1,1024}$/.test(tokens[0])?u:null;
}
function quote(value){
 const u=trusted(value);if(!u||u.searchParams.get('view')!=='customer-quotes')return null;
 const p=new URLSearchParams(u.hash.slice(1));
 return p.getAll('reference').length===1&&p.getAll('key').length===1&&/^VL-[A-F0-9]{10}$/.test(p.get('reference')||'')&&/^[a-f0-9]{64}$/.test(p.get('key')||'')?u:null;
}
function customer(value,origin,preview){
 const source=trusted(value),base=trusted(origin+'/');if(!source||!base)return null;
 const q=quote(value),booking=q?null:portal(value);
 const savedQuoteHub=source.pathname==='/'&&source.searchParams.get('view')==='customer-quotes'&&!source.hash;
 if(!q&&!booking&&!savedQuoteHub)return null;
 const target=new URL('/?view='+(q||savedQuoteHub?'customer-quotes':'customer-booking-status'),base.origin);
 const theme=preview||source.searchParams.get('preview_theme_id');if(/^\d{1,20}$/.test(theme||''))target.searchParams.set('preview_theme_id',theme);
 const hash=new URLSearchParams(source.hash.slice(1));
 if(q)target.hash=new URLSearchParams({reference:hash.get('reference'),key:hash.get('key')}).toString();
 else if(booking)target.hash=new URLSearchParams({vv247:hash.get('vv247')}).toString();
 return target;
}
window.VV247LinkSafety=Object.freeze({payment,portal,quote,customer});
})();
